@if (toaster.content()) {
	<rc-alert [type]="toaster.type()" (dismiss)="toaster.dismiss()"><div [innerHtml]="toaster.content()"></div></rc-alert>
}
